import { createSelector } from "reselect";

import type { GetPassengersChargeOptions } from "@app/helpers/udm/get-passengers-charge";
import { getPassengersCharge as getPassengersChargeHelper } from "@app/helpers/udm/get-passengers-charge";
import { getSegmentIdsPerLeg } from "@app/helpers/udm/get-segment-ids-per-leg";
import { getCartV2TripItem } from "@app/modules/checkout/utils/cart-v2";
import type { CheckoutCommonReduxState } from "@app/types/checkout-v2-types";
import type { TicketCharges } from "@app/types/napi-v2-charges-types";

import { getCartTicketChargesItems } from "./get-cart-ticket-charges-items";
import { getCart } from "./state-accessors";

const getTicketChargesForSegmentId = (
  ticket_charges: TicketCharges[],
  segment_id: string
) => {
  return ticket_charges.filter(tkt_charge => {
    return tkt_charge.segment_id === segment_id;
  });
};

export const getCheckoutCartPassengersCharge = createSelector(
  [
    getCart,
    getCartTicketChargesItems,
    (
      _: CheckoutCommonReduxState,
      opts: Partial<GetPassengersChargeOptions>,
      refreshed_charges: TicketCharges[] | undefined
    ) => {
      return { opts, refreshed_charges };
    }
  ],
  (cart, ticket_charges, { opts, refreshed_charges }) => {
    if (!cart) {
      return [];
    }

    const trip_item = getCartV2TripItem(cart.items);
    const segments_id_per_leg = getSegmentIdsPerLeg(trip_item?.trip_legs || []);

    const charges = refreshed_charges || ticket_charges;

    const charges_per_leg_and_segment = segments_id_per_leg.map(leg => {
      const leg_charges: TicketCharges[][] = [];
      leg.forEach(segment_id => {
        leg_charges.push(getTicketChargesForSegmentId(charges, segment_id));
      });
      return leg_charges;
    });

    return getPassengersChargeHelper(charges_per_leg_and_segment, opts);
  }
);
